import { ReactNode } from 'react';

import { Box as Flex, Typography as Text } from '@material-ui/core';

interface SummarySectionProps {
  title: string;
  children: ReactNode;
}

export const SummarySection = ({ title, children }: SummarySectionProps) => (
  <Flex
    display="flex"
    flexDirection="column"
    style={{
      gap: 'var(--encore-spacing-tighter-2)',
    }}
  >
    <Text
      variant="body2"
      color="textSecondary"
      style={{
        fontWeight: 'bold',
      }}
    >
      {title}
    </Text>
    {children}
  </Flex>
);
